'use client'
import styles from './FormBlock.module.scss'
import { Block_Form } from '@/src/generated/graphql'
import { classNames } from '@/src/helpers/component'
import Button from '@/src/components/common/Button'
import DirectusImage from '@/src/components/common/DirectusImage'

export default function ViewSuccess(_: Block_Form & { onBack: () => void }) {
  return (
    <div className={styles.successContainer}>
      <DirectusImage
        directusFile={_.form_submission_success_image}
        className={styles.succesImage}
      />
      <h3 className={styles.heading}>Submission successful!</h3>
      <div className={styles.subheading}>
        Thank you for your message. We have received your information and will process it shortly.
      </div>
      <hr className={classNames(styles.divider)} />
      <Button onClick={() => _.onBack()} className={styles.backButton}>
        Back to form
      </Button>
    </div>
  )
}
